import * as angular from 'angular';

import { WidgetBase, IMaximizable } from '../../widgets';
import { Helper } from '../../common';
import { IwidgetIntervalHelperService } from '../../services';
import { GroupStatesConfiguration } from './groupStates.configuration';
import { GroupStatesWidgetDefinition as definition } from '../../widgets/widgets.definition.index';
import { IGroupSelection } from '../models';

export class GroupStatesWidget extends WidgetBase implements IMaximizable, IGroupSelection {
    baseType = definition.baseType;
    col = 0;
    configuration: GroupStatesConfiguration;
    exportFormats = ['png', 'svg'];
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isDisabledMaximized = false;
    isExportable = true;
    isMaximizable = false;
    isMaximized = false;
    name = definition.title;
    row = 0;
    selectedGroupGuid: string;
    sizeX = 6;
    sizeY = 18;
    type = definition.type;

    constructor(private _intervalHelper: IwidgetIntervalHelperService) {
        super();
        this.guid = Helper.getGuid();
        this.configuration = new GroupStatesConfiguration();
    }

    getInterval(beginDate: string, endDate: string): { beginMoment: moment.Moment, endMoment: moment.Moment } {
        this.configuration.isEndDateIncluded = this.configuration.mode === 1;
        return this._intervalHelper.getInterval(beginDate, endDate, this.configuration);
    }
}